/**
 * Tipos de borda do cliente: os envelopes (paginação/coleções) e os nomes de
 * campo são EXATAMENTE os do `@zapir/shared` (contrato canônico). O que mora
 * aqui é só o que o shared não expõe por nome.
 */
import { message, type Message, type Notification, type Paginated } from "@zapir/shared";

/* ---------------- Tipos auxiliares de borda ---------------- */

/** Pagina canonica: `{ items, pageInfo: { nextCursor, hasMore } }`. */
export type Page<T> = Paginated<T>;

export type NotificationView = Notification;

/**
 * A timeline mistura mensagens do cliente e notas internas (doc 07 §1.6). O
 * DTO canonico `message` nao marca a nota; a API devolve o discriminador no
 * proprio item e aqui ele e preservado (passthrough), sem redefinir o contrato
 * compartilhado. A UI usa `isInternalNote` para renderizar a bolha amarela.
 */
export const timelineMessage = message.passthrough();
export type TimelineMessage = Message & {
  isInternalNote?: boolean;
  noteVisibility?: "team" | "admins";
  mentions?: { id: string; name: string }[];
  quotedPreview?: string | null;
  /** Nome de quem enviou (mensagens de grupo). */
  senderName?: string | null;
  /** Foto de quem enviou (mensagens de grupo). */
  senderAvatarUrl?: string | null;
};
